import { render, staticRenderFns } from "./LongQuestionAnswertest.vue?vue&type=template&id=73986246&scoped=true"
import script from "./LongQuestionAnswertest.vue?vue&type=script&lang=js"
export * from "./LongQuestionAnswertest.vue?vue&type=script&lang=js"
import style0 from "./LongQuestionAnswertest.vue?vue&type=style&index=0&id=73986246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.36.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73986246",
  null
  
)

export default component.exports